export default [
  {
    path: '/home',
    name: 'home',
    meta: {
      hideTab:true
    },
    component: () => import('@/views/home/index.vue')
  }
]